export default __webpack_public_path__ + "static/media/scissor.70588bee.png";